export default (url) => {
  if (!url) {
    return null;
  }
  if (url.indexOf('http://') === 0 || url.indexOf('https://') === 0) {
    return url;
  }
  return `https://${url}`;
};
